// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"57ff0440","326":"a533ec83","344":"68d955f1","463":"8fb1b473","538":"c26c4b03","552":"05dd949d","588":"d8f8c88d","806":"792395c7","936":"97a416df"}[chunkId] + ".chunk.js";
};